<template>
  <div class="Cart" :class="{Cart__active :active}">
    <div class="Cart__header">
      <div class="Cart__close" @click="active=false">
        <i class="fa fa-times"></i>
      </div>
      <div class="Cart__title">BAĞIŞ SEPETİ</div>
    </div>
    <div class="line mb-5"></div>
    <div class="Cart__body">
      <div class="Cart__item" v-for="(item, idx) in cart.basketItems" :key="idx">
        <div class="Cart__item--img">
          <img :src="img(item.image)" alt />
        </div>
        <div class="Cart__item--title">
          <span>{{item.title}} &nbsp; <strong v-if="item.quantity > 1">x{{item.quantity}}</strong></span>
          <br />
          <span
            class="Cart__item--title-other"
            v-if="item.other_name"
          >{{item.other_name}}-{{item.other_phone}}</span>
        </div>
        <div class="Cart__item--title ml-2" v-if="item.quantity > 0"></div>
        <div class="Cart__item--price">{{parseFloat(item.price * item.quantity).toLocaleString()}} ₺</div>
        <div class="Cart__item--del" @click="deleteItem(idx)"><i class="fas fa-times"></i></div>
      </div>
    </div>

    <div class="Cart__footer" v-if="isCartEmpty">
      <div class="Cart__footer--title">Toplam</div>
      <div class="Cart__footer--total">{{totalPrice.toLocaleString()}} ₺</div>
    </div>

    <div class="Cart__form" v-if="isCartEmpty">
      <div class="Cart__form--donator-name" v-if="! user.loggedIn">
        <label for>Bağışçı Adı Soyadı</label>
        <div class="Cart__form--input-box">
          <i class="fa fa-user icon"></i>
          <input v-model="donator_name" type="text" placeholder="Bağışçının adı soyadını giriniz" />
        </div>
      </div>
      <div class="Cart__form--donator-phone mt-4" v-if="! user.loggedIn">
        <label for>Cep Telefonu</label>
        <div class="Cart__form--input-box">
          <i class="fas fa-phone-alt icon"></i>
          <multiselect
            v-model="country_phone_code"
            :options="phoneCountryCodesObj"
            class="rounded-0"
            :multiple="false"
            :close-on-select="true"
            :hide-selected="false"
            :preserve-search="true"
            selectedLabel
            select-label
            deselectLabel
            placeholder
            label="label"
            track-by="name"
          >
            <template slot="singleLabel" slot-scope="props">
              +{{ props.option.name }}
            </template>
          </multiselect>
          <the-mask
            class="px-0" v-if="country_phone_code.name == 90"
            :mask="['(###) ### ## ##']"
            v-model="donator_phone"
            placeholder="Cep telefonu giriniz"
          />
          <input
            type="text"
            v-model="donator_phone"
            v-if="country_phone_code.name != 90"
            class="px-0"
            placeholder="Cep telefonu giriniz"
          >
        </div>
      </div>
      <div class="Cart__form--donator-name">
        <label class="mt-2" for>Bağışçı Notu</label>
        <div class="Cart__form--input-box">
          <textarea v-model="donator_note" style="width:100%" rows="3" />
        </div>
      </div>
      <div class="line" v-if="! user.loggedIn"></div>

      <div class="Cart__form--card-full-name mt-4">
        <label for>Kredi Kartı Adı Soyadı</label>
        <div class="Cart__form--input-box">
          <i class="fas fa-user icon"></i>
          <input v-model="cc_name" type="text" placeholder="Kart sahibinin adı soyadı" />
        </div>
      </div>

      <div class="Cart__form--card-number mt-4">
        <label for>Kart Numarası</label>
        <div class="Cart__form--input-box">
          <i class="fas fa-credit-card icon"></i>
          <the-mask type="text" v-model="cc_number" :mask="['#### #### #### ####']" placeholder="Kart numarasını giriniz" />
        </div>
      </div>

      <div class="d-flex justify-content-between mt-4">
        <div class="Cart__form--cart-date" style="width: 45%">
          <label for>Geçerlilik Tarihi</label>
          <div class="Cart__form--select-box">
            <select v-model="cc_month">
                <option disabled value="">Ay</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>

            <span>/</span>
            <select v-model="cc_year">
                <option selected value="">Yıl</option>
                <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
              </select>
          </div>
        </div>
        <div class="Cart__form--cart-cvv" style="width: 45%">
          <label for>CVV</label>
          <div class="Cart__form--input-box">
            <the-mask class="px-0" :mask="['###']" v-model="cc_cvv" />
          </div>
        </div>
      </div>

      <div class="Cart__form--button mt-5">
        <div class="Cart__form--read">
           <input type="checkbox" v-model="isChecked">
        <p><router-link to='i/uyelik-ve-bagis-sozlesmesi'>Üyelik ve Bağış Sözleşmesini</router-link> Okudum Kabul Ediyorum</p>
        </div>
        <button :disabled="loading" :class="{loading}" class="button" @click="complateOrder">
          Ödemeyi Tamamla
          <i v-if="loading" class="fas fa-spin fa-spinner"></i>
        </button>
      </div>
    </div>
    <div class="Cart__empty" v-if="!isCartEmpty">
      <p>Bağış sepetinize henüz bir bağış eklemediniz.</p>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { TheMask } from 'vue-the-mask'
import Multiselect from 'vue-multiselect'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      isChecked: true,
      loading: false,
      donator_name: '',
      donator_phone: '',
      donator_note: '',
      cc_name: '',
      cc_number: '',
      cc_month: '',
      cc_year: '',
      cc_cvv: '',
      active: false,
      phoneCountryCodesObj: [],
      country_phone_code: {
        id: '+90',
        name: '90',
        label: '+90'
      }
    }
  },
  components: {
    TheMask,
    Multiselect
  },
  computed: {
    ...mapState(['cart']),
    years() {
      const year = new Date().getFullYear()
      return Array.from({ length: 100 }, (value, index) => year + index)
    },
    ...mapGetters(['totalPrice', 'totalBasketItems']),
    isCartEmpty() {
      return this.totalBasketItems > 0
    }
  },
  methods: {
    ...mapActions(['deleteFromCart', 'fetchBasketFromLocal']),
    clearCart() {
      this.cc_name = ''
      this.cc_number = ''
      this.cc_month = ''
      this.cc_year = ''
      this.cc_cvv = ''
      this.donator_name = ''
      this.donator_phone = ''
    },
    complateOrder() {
      if (this.isChecked) {
        const items = this.cart.basketItems.map(item => ({
          id: item.id,
          price: item.price,
          other_name: item.other_name,
          quantity: item.quantity,
          other_phone: item.other_phone
        }))

        const ccYear = this.cc_year.toString().substr(2, 2)
        const data = {
          donator_name: this.donator_name,
          donator_phone: this.donator_phone,
          country_phone_code: this.country_phone_code.name,
          cc_name: this.cc_name,
          cc_number: this.cc_number,
          cc_year: ccYear,
          cc_month: this.cc_month,
          cc_cvv: this.cc_cvv,
          items
        }

        window.localStorage.setItem('donator_note', this.donator_note)
        this.donator_note = ''
        this.$modal.show('payment-modal', { data })
      } else {
        Swal.fire({
          title: 'Lütfen üyelik ve bağış sözleşmesini onaylayınız.',
          type: 'warning',
          confirmButtonText: 'Tamam'
        })
      }
    },
    deleteItem(idx) {
      Swal.fire({
        title: 'Bağışı silmek istediğinize emin misiniz?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'İptal'
      }).then((res) => {
        if (res.value) {
          this.deleteFromCart(idx)
        }
      })
    }
  },
  created() {
    this.$root.$on('open-nav', (data) => {
      this.active = data
    })

    this.$root.$on('clear_cart', () => {
      this.clearCart()
    })

    this.loadCountries()
    if (process.env.NODE_ENV === 'development') {
      this.donator_name = 'Ahmet Yılmaz'
      this.donator_phone = `${this.country_phone_code}5078871336`
      this.cc_name = 'Ahmet Yılmaz'
      this.cc_number = '4033602562020327'
      this.cc_month = '01'
      this.cc_year = '2020'
      this.cc_cvv = '861'
    }
  }
}
</script>
